import React from 'react'
import { Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const SectionHeader = ({
  title,
  subtitle,
  headerLink,
  headerLinkHandler,
  styles
}) => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()
  return (
    <div className={`${classes.header} section-header`}>
      <div className={classes.title}>
        <p
          id={
            title === 'Interventions'
              ? 'pendo-intervention-summary-section-title-tag'
              : `${title}-section-title`
          }
          className={`${classes.titleText} title-text`}
        >
          {title}
        </p>
        {headerLink && (
          <Link
            color="primary"
            onClick={() => headerLinkHandler()}
            className={classes.headerLink}
            tabIndex="0"
            role="button"
            onKeyDown={e => {
              const key = e.which
              if (key === 13 || key === 32) headerLinkHandler()
            }}
          >
            {headerLink}
          </Link>
        )}
      </div>
      <p className={classes.subtitle}>{subtitle}</p>
    </div>
  )
}

export default SectionHeader
